import { createFileRoute } from "@tanstack/react-router";
import { SyncOpsIndexPage } from "./-syncs/sync-ops-index.page";

export const Route = createFileRoute("/_dashboard/$datasetSlug/apps/syncs/")({
  component: SyncOpsIndexPage,
});
